import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  type User,
} from 'firebase/auth';
import { auth } from './firebase';


export async function loginEmail(email: string, password: string): Promise<User> {
  const cred = await signInWithEmailAndPassword(auth, email, password);
  return cred.user;
}

export async function resetPassword(email: string): Promise<void> {
  await sendPasswordResetEmail(auth, email);
}

export async function logout(): Promise<void> {
  await signOut(auth);
}

/** Force a refresh of the ID token to pick up newly-set custom claims. */
export async function refreshClaims(): Promise<void> {
  const u = auth.currentUser;
  if (u) await u.getIdToken(true);
}
